import { render, staticRenderFns } from "./SmyXAddress.vue?vue&type=template&id=b1ab5aac&scoped=true&"
import script from "./SmyXAddress.vue?vue&type=script&lang=js&"
export * from "./SmyXAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab5aac",
  null
  
)

export default component.exports